module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_vm._v("The One remains, the many change and pass;")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_vm._v("Heaven’s light forever shines, Earth’s shadows fly;")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_vm._v("Life, like a dome of many-coloured glass,")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_vm._v("Stains the white radiance of Eternity …")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Percy Bysshe Shelley")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_c('i', [_vm._v("Adonais")]), _vm._v(" LII")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4984e832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter04.vue
// module id = 81
// module chunks = 0